export const commonModalClasses =
  "dark:bg-secondary bg-white drop-shadow-lg rounded p-6 space-y-6";

export const commonInputClasses =
  "w-full bg-transparent outline-none dark:border-dark-subtle border-light-subtle dark:focus:border-white focus:border-primary transition dark:text-white text-primary";
